import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import LocalStorageService from "@services/localStorage";

import en from "./utils/localizations/en";
import sv from "./utils/localizations/sv";

const resources = {
  enUS: {
    translation: en,
  },
  sv: {
    translation: sv,
  },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "sv",
    lng: LocalStorageService.getLanguage(),
    debug: false,
    resources,
    keySeparator: ".",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
document.documentElement.lang = i18n.language;

export default i18n;
